import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillYoutube,
  AiFillFacebook,
  AiFillInstagram,
  AiFillAppstore
} from "react-icons/ai";
import { IoLogoGooglePlaystore } from "react-icons/io5";

import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>HV Pubudu Indie Game Studio</h3>
        </Col>
     
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://play.google.com/store/apps/developer?id=HV+Pubudu"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <IoLogoGooglePlaystore />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.youtube.com/@pubuduhewavithana2396"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillYoutube />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://web.facebook.com/people/Pixel-Zombie-War-Z-Defense/61558345131734/"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillFacebook />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/pixel_zombie_war/"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
